export const reactToastify = {
  '.eds-react-toastify_toast-container': {
    maxHeight: '50vh',
    maxWidth: 'calc(100vw - 32px)',
    minHeight: 'unset',
    minWidth: 'toast.width',
    overflowY: 'auto',
    padding: 0,
    width: 'toast.width',
  },
  '.Toastify__toast-container--bottom-center': {
    marginLeft: '0 !important',
    transform: 'translateX(-50%)',
  },
};
